import Icon from './Icon';

enum Gender {
  female = 'venus',
  male = 'mars'
}

type PropsGenderIcon = {
  gender: 'female' | 'male';
  fontSize?: number;
  className?: string;
}

export function GenderIcon({ gender, fontSize, className, ...props }: PropsGenderIcon) {
  if (!gender){
    return null
  }
  return (
    <Icon
      icon={Gender[gender]}
      iconLibrary="far"
      fontSize={fontSize}
      {...props}
    />
  );
}

export default GenderIcon;
